import React from 'react';
import ViewAdminSchedules from '../ViewAdminSchedules';

const ScheduleBySpecialityPage = () => <ViewAdminSchedules scheduleType="speciality" />;

export default ScheduleBySpecialityPage;
